import React from 'react';
import CustomButtonStyle from '@/styles/components/careers/button-style/_index.module.scss';
import { Formik, FormikControl, Form, InputError, InputStyle, Button, Checkbox, BUTTON_STYLES_OPTIONS} from '@/imports-files/pages/career/customize-career-page';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import ColorPickerf from '@/components/color-pickerf';

export function CustomButtons({formik, sidebar_section, customizeCareerAction, setFonts}){
  return(
    <div className = {`${CustomButtonStyle.CustomButtons}`}>
      <label className = {`${CustomButtonStyle.CustomButtons__Title}`}>Button Style</label>
      {/*<div className = {`${CustomButtonStyle.CustomButtons__Fields__LeftContent}`}>
          <div className = {`${CustomButtonStyle.CustomButtons__Fields__Label}`}>
            <label>Fill</label>
          </div>
          <div className={`${CustomButtonStyle.CustomButtons__Fields__Input}`}>
            <FormikControl
              control       =   "select"
              options       =   {BUTTON_STYLES_OPTIONS.fill}
              name          =   {'career_button_style.style_hash.fill'}
              career        =   {`${CustomButtonStyle.CustomButtons__Select} CareerSelect`}
              formik        =   {formik}
              placeholder   =   "Solid"
              default       =  {formik.values.career_button_style_attributes.style_hash.fill}
              onChange      =   {(option) => customizeCareerAction.fontStyleChange(option, formik, 'fill', 'button', 0, setFonts)}
            />
          </div>
        </div>*/}
      <div className = {`${CustomButtonStyle.CustomButtons__Fields}`}>
        <div className = {`${CustomButtonStyle.CustomButtons__Fields__LeftContent}`}>
          <div className = {`${CustomButtonStyle.CustomButtons__Fields__Label}`}>
            <label>Border Radius</label>
          </div>
          <div className={`${CustomButtonStyle.CustomButtons__Fields__Input}`}>
            <FormikControl
              control       =   "input"
              type          =   "text"
              placeholder   =   "22"
              name          =   {'career_button_style_attributes.style_hash.borderRadius'}
              className     =   {CustomButtonStyle.CustomButtons__Input}
              formik        =   {formik}
              onChange      =   {(evt) => {
                customizeCareerAction.fontStyleChange(evt, formik, 'border_radius', 'button')
              }}
            />
          </div>
        </div>
         <div className = {`${CustomButtonStyle.CustomButtons__Fields__RightContent}`}>
          <div className = {`${CustomButtonStyle.CustomButtons__Fields__Label}`}>
            <label>Font Size</label>
          </div>
          <div className={`${CustomButtonStyle.CustomButtons__Fields__Input}`}>
            <FormikControl
              control       =   "select"
              options       =   {customizeCareerAction.fontSizeOptions('button_text')}
              name          =   {'career_button_style_attributes.style_hash.fontSize'}
              career        =   {`${CustomButtonStyle.CustomButtons__Select} CareerSelect`}
              formik        =   {formik}
              placeholder   =   "24px"
              default       =  {formik.values.career_button_style_attributes.style_hash.fontSize}
              onChange      =   {(option) => customizeCareerAction.fontStyleChange(option, formik, 'font_size', 'button')}
            />
          </div>
        </div>
        {/*<div className = {`${CustomButtonStyle.CustomButtons__RightButtonContent}`}>
          <div className = {`${CustomButtonStyle.CustomButtons__Fields__Label} ${CustomButtonStyle.CustomButtons__VisibiltyHidden}`}>
              <label>Button Preview</label>
          </div>
          <Button type="button" style={customizeCareerAction.heroButtonStyle(formik)} buttonstyle={`${CustomButtonStyle.CustomButtons__ButtonPreview}`}>
              Button
          </Button>
        </div>*/}

        {/*<div className = {`${CustomButtonStyle.CustomButtons__Fields__RightContent}`}>
          <div className = {`${CustomButtonStyle.CustomButtons__Fields__Label}`}>
              <label>Fill</label>
            </div>
            <div className= {`${CustomButtonStyle.CustomButtons__Fields__ColorInput}`}>
              <ColorPickerf formik={formik} color={formik.values.career_button_style_attributes.style_hash.backgroundColor}
                handleChange={(color) => customizeCareerAction.fontStyleChange(color, formik, 'background_color', 'button')}
                isDisabled={formik.values.career_button_style_attributes.style_hash.fill == 'outline'}
              />
            </div>
        </div>*/}
      </div>
      <div className = {`${CustomButtonStyle.CustomButtons__DFlex}`}>
        <label className = {`${CustomButtonStyle.CustomButtons__Title} pt0`}>Hero Button</label>
        <div className = {`${CustomButtonStyle.CustomButtons__Fields}`}>
          <div className = {`${CustomButtonStyle.CustomButtons__RightButtonContent}`}>
            <Button type="button" style={customizeCareerAction.heroButtonStyle(formik)} buttonstyle={`${CustomButtonStyle.CustomButtons__ButtonPreview}`}>
                Button
            </Button>
          </div>
        </div>
      </div>
      <div className = {`${CustomButtonStyle.CustomButtons__Fields}`}>
        <div className = {`${CustomButtonStyle.CustomButtons__Fields__LeftContent}`}>
          <div className = {`${CustomButtonStyle.CustomButtons__Fields__Label}`}>
            <label>Background Colour</label>
          </div>
          <div className= {`${CustomButtonStyle.CustomButtons__Fields__ColorInput}`}>
              <ColorPickerf formik={formik} color={formik.values.career_button_style_attributes.hero_button?.background_color}
                handleChange={(color) => customizeCareerAction.fontStyleChange(color, formik, 'hero_button_background_color', 'button')}
              />
            </div>
        </div>
        <div className = {`${CustomButtonStyle.CustomButtons__Fields__RightContent}`}>
          <div className = {`${CustomButtonStyle.CustomButtons__Fields__Label}`}>
              <label>Font Colour</label>
            </div>
            <div className= {`${CustomButtonStyle.CustomButtons__Fields__ColorInput}`}>
              <ColorPickerf formik={formik} color={formik.values.career_button_style_attributes.hero_button?.font_color}
                handleChange={(color) => customizeCareerAction.fontStyleChange(color, formik, 'hero_button_font_color', 'button')}
              />
            </div>
        </div>
      </div>

      <div className = {`${CustomButtonStyle.CustomButtons__DFlex}`}>
        <label className = {`${CustomButtonStyle.CustomButtons__Title} pt0`}>View more jobs button</label>
        <div className = {`${CustomButtonStyle.CustomButtons__Fields}`}>
          <div className = {`${CustomButtonStyle.CustomButtons__RightButtonContent}`}>
            <Button type="button" style={customizeCareerAction.viewMoreButtonStyle(formik)} buttonstyle={`${CustomButtonStyle.CustomButtons__ButtonPreview}`}>
                Button
            </Button>
          </div>
        </div>
      </div>
      <div className = {`${CustomButtonStyle.CustomButtons__Fields} pb20`}>
        <div className = {`${CustomButtonStyle.CustomButtons__Fields__LeftContent}`}>
          <div className = {`${CustomButtonStyle.CustomButtons__Fields__Label}`}>
            <label>Background Colour</label>
          </div>
          <div className= {`${CustomButtonStyle.CustomButtons__Fields__ColorInput}`}>
              <ColorPickerf formik={formik} color={formik.values.career_button_style_attributes.view_more_job_button?.background_color}
                handleChange={(color) => customizeCareerAction.fontStyleChange(color, formik, 'view_more_job_button_background_color', 'button')}
              />
            </div>
        </div>
        <div className = {`${CustomButtonStyle.CustomButtons__Fields__RightContent}`}>
          <div className = {`${CustomButtonStyle.CustomButtons__Fields__Label}`}>
              <label>Font Colour</label>
            </div>
            <div className= {`${CustomButtonStyle.CustomButtons__Fields__ColorInput}`}>
              <ColorPickerf formik={formik} color={formik.values.career_button_style_attributes.view_more_job_button?.font_color}
                handleChange={(color) => customizeCareerAction.fontStyleChange(color, formik, 'view_more_job_button_font_color', 'button')}
              />
            </div>
        </div>
        {/*<div className = {`${CustomButtonStyle.CustomButtons__Fields__RightContent}`}>
          <div className = {`${CustomButtonStyle.CustomButtons__Fields__Label} ${CustomButtonStyle.CustomButtons__VisibiltyHidden}`}>
              <label>Font Style</label>
            </div>
            <div className= {`${CustomButtonStyle.CustomButtons__CheckboxInput} FontStyle`}>
                <div className = 'BoldStyle'>
                  <FormControlLabel
                    control={<Checkbox checked={customizeCareerAction.fontStyleChecked(formik, 'font_weight', 'button')} onChange={(event) => customizeCareerAction.fontStyleChange(event, formik, 'font_weight', 'button')} />}
                    label="B"
                  />
                </div>
                <div className = 'ItalicStyle'>
                  <FormControlLabel
                      control={<Checkbox checked={customizeCareerAction.fontStyleChecked(formik, 'font_style', 'button')} onChange={(event) => customizeCareerAction.fontStyleChange(event, formik, 'font_style', 'button')} />}
                      label="I"
                    />
                </div>
                <div className = 'UnderlineStyle'>
                  <FormControlLabel
                      control={<Checkbox checked={customizeCareerAction.fontStyleChecked(formik, 'text_decoration', 'button')} onChange={(event) => customizeCareerAction.fontStyleChange(event, formik, 'text_decoration', 'button')} />}
                      label="U"
                    />
                </div>
            </div>
        </div>*/}
      </div>
    </div>
  )
}